import { Component, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { take } from 'rxjs';
import { Ga4Service } from '../services/ga4.service';

@Component({
  selector: 'rap-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements AfterViewInit {
  @ViewChild('demoVideo') demoVideo: ElementRef<HTMLVideoElement>;
  title = 'Welcome to Angular';
  currentYear = new Date().getFullYear();
  features = [
    {
      icon: 'assets/images/key_Icon.svg',
      title: 'Advanced Search',
      description: 'Unlock search filters, metadata\nanalysis, and semantic data on\njoy, anger, sadness, and fear.'
    },
    {
      icon: 'assets/images/key_Icon2.svg',
      title: 'Data Visualizations',
      description: 'Transform raw data into\ninsightful charts, maps and\ngraphs.'
    },
    {
      icon: 'assets/images/key_Icon3.svg',
      title: 'Social Cards',
      description: 'Share insights easily with\nfriends and analyze data\nseamlessly on the go.'
    },
    {
      icon: 'assets/images/key_Icon4.svg',
      title: 'API Access & Data Export',
      description: 'Integrate hip-hop data into your\nown research and creative\ntechnology projects.'
    }
  ];

  itFor = [
    {
      icon: 'assets/images/It_Icon1.svg',
      title: 'Researchers',
      description: 'Unlock deep cultural and\nlinguistic insights.'
    },
    {
      icon: 'assets/images/It_Icon2.svg',
      title: 'Educators',
      description: 'Engage students with\ninteractive analysis tools.'
    },
    {
      icon: 'assets/images/It_Icon3.svg',
      title: 'Developers',
      description: 'Build apps and tools with API\n-powered data.'
    },
    {
      icon: 'assets/images/It_Icon4.svg',
      title: 'Consultants',
      description: 'Get expert support and custom\nsolutions for hip-hop data analysis.'
    }
  ];

  footerSections = [
    {
      title: 'Rap Almanac',
      items: [
        { label: 'Home', link: '#', scrollToTop: true },
        { label: 'Pricing', link: '#', scrollToTop: true },
        { label: 'Terms', link: '/privacy-notice' },
        { label: 'Privacy', link: '/privacy-notice' }
      ]
    },
    {
      title: 'Social',
      items: [
        { label: 'Facebook', link: 'https://facebook.com/rapresearchlab' },
        { label: 'Twitter', link: 'https://twitter.com/rapresearchlab' },
        { label: 'Instagram', link: 'https://instagram.com/rapresearchlab' },
        { label: 'Contact us', link: 'https://docs.google.com/forms/d/1jgl1biJHccPC6aIIVY28nPN2rt-NGvIe9Npn_qGQ7T0/edit?pli=1' }
      ]
    }, {
      title: 'Affiliates',
      items: [
        { label: 'Rap Research Lab', link: 'https://www.rapresearchlab.com' },
        { label: 'Mapper’s Delight', link: 'https://www.mappersdelight.net' },
        { label: 'Staple Crops Studio', link: 'https://staplecrops.com' }
      ]
    }
  ];

  constructor(private router: Router, private route: ActivatedRoute,
    private ngZone: NgZone, private ga4: Ga4Service
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const video = this.demoVideo.nativeElement;
    video.muted = true;
    video.addEventListener('canplay', () => {
      video.play().catch(() => {});
    }, { once: true });

    if (video.readyState >= 3) {
      video.play().catch(() => {});
    }

    this.route.queryParams.subscribe((params) => {
      const isPricing = params['isPricing'];
      console.log('isPricing:', isPricing);
      if (isPricing) {
        // setTimeout(() => {
        //   const element = document.getElementById('pricingId');
        //   console.log('element:', element);
        //   if (element) {
        //     element.scrollIntoView({ behavior: 'smooth' });
        //     // this.scrollToSection('pricingId');
        //   }
        // }, 0);
        this.ngZone.onStable.pipe(take(1)).subscribe(() => {
          setTimeout(() => {
            const element = document.getElementById('pricingId');
            if (element) {
              console.log('Found element:', element);
              element.scrollIntoView({ behavior: 'smooth' });
            } else {
              console.warn('Element with id pricingId not found.');
            }
          }, 200); // try 20
        });
      }
    });
  }

  onContactUs() {
    window.open('https://docs.google.com/forms/d/1jgl1biJHccPC6aIIVY28nPN2rt-NGvIe9Npn_qGQ7T0/edit?pli=1', '_blank');
  }

  onSignup(): void {
    this.ga4.event('sign_up_cta_click', { source: 'landing_page' });
    // this.router.navigate(['/create-account']);
    this.scrollToSection('pricingId');
  }

  onSignin(): void {
    this.router.navigate(['/signin']);
  }

  onPricing(): void {
    this.ga4.event('upgrade_cta_click', { source: 'landing_page' });
    this.scrollToSection('pricingId');
  }

  onDownload(): void {
    this.scrollToSection('pricingId');
  }

  toggleMobileMenu() {
    const buttons = document.querySelector('.buttons');
    buttons.classList.toggle('mobile-menu');
  }


  scrollToTop(): void {
    const contentEl = document.getElementById('content');
    if (contentEl) {
      contentEl.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  handleFooterLinkClick(item: any): void {
    console.log('Footer link clicked:', item);
    if (item.scrollToTop && item.label === 'Pricing') {
      this.scrollToSection('pricingId');  // Scroll to the pricing section
    } else if (item.scrollToTop && item.label === 'Home') {
      this.scrollToTop();
    } else if (item.scrollToTop && item.label === '"Privacy"') {

    } else if (item.scrollToTop && item.label === '"Terms"') {
      window.open('/privacy-notice', '_blank');
    }
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

}
